import BoxIcon from "../../../../../components/ui/box-icon/box-icon";
import "./contacts-cards-card.scss";

export type ContactsCardsCardElementT = {
  title: string;
  text: string;
  icon: string;
  iconType: "primary" | "secondary" | "primary-rounded" | "secondary-rounded";
  href?: string;
  onClick?: () => void;
};

type ContactsCardsCardPropsT = {
  title: string;
  iconTitle: string;
  iconTitleType:
    | "primary"
    | "secondary"
    | "tertiary"
    | "primary-rounded"
    | "secondary-rounded"
    | "tertiary-rounded";
  elementList: ContactsCardsCardElementT[];
};

const ContactsCardsCard = ({
  title,
  iconTitle,
  iconTitleType,
  elementList,
}: ContactsCardsCardPropsT) => {
  return (
    <div className="contacts-cards-card">
      <div className="contacts-cards-card__icon-title">
        <BoxIcon icon={iconTitle} size={"medium"} type={iconTitleType} />
        <h2>{title}</h2>
      </div>
      <div className="contacts-cards-card__list">
        {elementList.map((el, i) => {
          const content = (
            <div className="contacts-cards-card__list-el-icon-title">
              <BoxIcon icon={el.icon} size={"small"} type={el.iconType} />
              <div className="contacts-cards-card__list-el-info">
                <h3>{el.title}</h3>
                <span className="contacts-cards-card__list-el-text">
                  {el.text}
                </span>
              </div>
            </div>
          );

          if (el.href) {
            return (
              <a
                className="contacts-cards-card__list-element contacts-cards-card__list-element--action"
                key={`${i}-${el.title}`}
                href={el.href}
              >
                {content}
              </a>
            );
          }

          if (el.onClick) {
            return (
              <button
                type="button"
                className="contacts-cards-card__list-element contacts-cards-card__list-element--action"
                key={`${i}-${el.title}`}
                onClick={el.onClick}
              >
                {content}
              </button>
            );
          }

          return (
            <div
              className="contacts-cards-card__list-element"
              key={`${i}-${el.title}`}
            >
              {content}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ContactsCardsCard;
